import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { SchoolingRoutingModule } from '@frontend/modules/schooling/schooling-routing.module';
import { SchoolingTuitionDetailsComponent } from './schooling-tuition-details/schooling-tuition-details.component';
import { SchoolingTuitionListComponent } from './schooling-tuition-list/schooling-tuition-list.component';
import { SchoolingTuitionDetailsParticipantsComponent } from './schooling-tuition-details-participants/schooling-tuition-details-participants.component';
import { SchoolingOnlineStartComponent } from './schooling-online-start/schooling-online-start.component';
import { SchoolingIndexContentComponent } from './schooling-index-content/schooling-index-content.component';
import { SchoolingBookletContentComponent } from './schooling-booklet-content/schooling-booklet-content.component';
import { SchoolingTuitionParticipantsDialogsComponent } from './schooling-tuition-participants-dialogs/schooling-tuition-participants-dialogs.component';

@NgModule({
    declarations: [
        SchoolingTuitionDetailsComponent,
        SchoolingTuitionListComponent,
        SchoolingTuitionDetailsParticipantsComponent,
        SchoolingOnlineStartComponent,
        SchoolingBookletContentComponent,
        SchoolingIndexContentComponent,
        SchoolingTuitionParticipantsDialogsComponent
    ],
    imports: [
        SharedModule,
        // SchoolingRoutingModule,
    ],
  exports: [
    SchoolingOnlineStartComponent,
    SchoolingIndexContentComponent,
  ]
})
export class SchoolingModule {}
